import React from 'react';
import './FNavLink.css'

const FNavLink = (props) => {
    return ( 
        <a className='FNavLink' href="../../Pages/Home.jsx">{props.FNavText}</a>
     );
}
 
export default FNavLink;